import { NotePage } from "@c/NotePage";
import { useNotebookStore } from "@store/index";
import { observer } from "mobx-react-lite";
import type { NextPage } from "next";
import React from "react";

const Page: NextPage = observer(() => {
  const notebook = useNotebookStore();
  const today = notebook.today;
  return <NotePage note={today} />
});

export default Page;
